import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "text-left col-6" }, [
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _vm.historyPageToken && _vm.queryResponse
            ? _c(
                "b-button-group",
                [
                  _vm.historyPageToken.index > 1
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mr-1",
                          attrs: {
                            color: "secondary",
                            disabled: _vm.disabled,
                            small: "",
                            elevation: "5",
                          },
                          on: { click: _vm.goFirst },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-chevron-double-left",
                          }),
                          _vm._v(_vm._s(_vm.$t("botones.boton_primero"))),
                        ]
                      )
                    : _vm._e(),
                  _vm.historyPageToken.list[_vm.historyPageToken.index]
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mr-1",
                          attrs: {
                            disabled: _vm.disabled,
                            color: "default",
                            small: "",
                            elevation: "5",
                          },
                          on: { click: _vm.goPrev },
                        },
                        [
                          _c("i", { staticClass: "mdi mdi-chevron-left" }),
                          _vm._v(_vm._s(_vm.$t("botones.boton_anterior"))),
                        ]
                      )
                    : _vm._e(),
                  _vm.hasToken
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mr-1",
                          attrs: {
                            disabled: _vm.disabled,
                            color: "primary",
                            small: "",
                            elevation: "5",
                          },
                          on: { click: _vm.goNext },
                        },
                        [
                          _vm._v(_vm._s(_vm.$t("botones.boton_siguiente"))),
                          _c("i", { staticClass: "mdi mdi-chevron-right" }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }